import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import React from "react";

import { css } from "@emotion/react";

import { CloseButtonSvg } from "../../../assets";
import { CSS_MQ } from "../../../styles/breakpoints";
import { CSS_COLORS } from "../../../styles/styles-css-variables";
import { fontColor, FONTS, fontSize } from "../../../styles/fonts";

export const UITags: ReactTFC<{
  elements: Array<{ key: string; onClick: () => void; label: React.ReactNode }>;
}> = props => {
  return props.elements.length > 0 ? (
    <div css={wrapperStyles}>
      {props.elements.map(element => {
        return (
          <button key={element.key} css={buttonStyles} onClick={element.onClick}>
            <span
              css={css`
                text-transform: none;
              `}
            >
              {element.label}
            </span>

            <CloseButtonSvg css={closeButtonStyles} />
          </button>
        );
      })}
    </div>
  ) : null;
};

const wrapperStyles = css`
  --p: 8px;
  --h: 12px;
  ${CSS_MQ.atLeastMd} {
    --p: 12px;
    --h: 40px;
  }

  margin-top: 30px;

  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

const buttonStyles = [
  FONTS.SwarovskiFutura300,
  fontColor.black,
  fontSize.x2,
  css`
    padding: 10px 16px 8px;

    border-width: 2px;
    border-color: ${CSS_COLORS.Green};
    border-style: solid;

    border-radius: 20px;

    display: flex;
    gap: 20px;
    align-items: center;

    text-transform: uppercase;

    &:hover {
      background-color: ${CSS_COLORS.GrayLight2024};
    }
  `,
];

const closeButtonStyles = css`
  width: 18px;
  height: 18px;
  margin-top: -1px;
  margin-right: -3px;
`;
